import {
  Box,
  Breadcrumbs,
  Link,
  Paper,
  Typography,
} from "@mui/material";
import {
  DataGrid,
} from "@mui/x-data-grid";
import { useState, useEffect } from "react";
import * as services from "./../../services/saleng";
import SubjectIcon from "@mui/icons-material/Subject";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

function formatNumber(number) {
  return number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const Reports = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [shopId, setShopId] = useState(null);

  const columns = [
    {
      field: "billNumber",
      headerName: "เลขบิล",
      flex: 1,
    },
    {
      field: "date",
      headerName: "วันที่",
      flex: 1,
    },
    {
      field: "branchName",
      headerName: "สาขา",
      flex: 1,
    },
    {
      field: "customerName",
      headerName: "ชื่อลูกค้า",
      flex: 1,
    },
    {
      field: "totalWeight",
      headerName: "น้ำหนักสุทธิ",
      type: "number",
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            {params.row.totalWeight}
            <span style={{ color: "gray" }}>{" กิโล"}</span>
          </>
        );
      },
    },
    {
      field: "totalAmount",
      headerName: "ราคาสุทธิ",
      type: "number",
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            {params.row.totalAmount}
            <span style={{ color: "gray" }}>{" บาท"}</span>
          </>
        );
      },
    },
    {
      field: "description",
      headerName: "ข้อมูลเพิ่มเติม",
      flex: 0,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <SubjectIcon
            onClick={() => navigate("/reports/" + params.row.transactionId)}
          />
        );
      },
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      if (!shopId) return;

      services
        .getShopTransaction(shopId)
        .then((response) => {
          const transaction = response.data.data;
          const TransactionWithIndex = transaction.map((item, index) => {
            // แปลง ISO datetime เป็น Date object
            const date = new Date(item.createdAt);

            // คำนวณเวลาตาม Timezone ของเครื่อง
            const localDate = new Date(
              date.getTime() - date.getTimezoneOffset() * 60000
            );

            // แปลงเป็นรูปแบบ YYYY-MM-DD HH:mm:ss
            const formattedDate = localDate
              .toISOString()
              .replace("T", " ")
              .split(".")[0];

            return {
              ...item,
              id: index + 1,
              TransactionId: item.transactionId,
              date: formattedDate, // วันที่ + เวลาเครื่อง
              branchName: item.branch.name,
              customerName: item.customerName,
              totalWeight: formatNumber(item.totalWeight),
              totalAmount: formatNumber(item.totalAmount),
              description: "",
            };
          });

          setRows(TransactionWithIndex);
        })
        .catch((error) => {
          console.log("error : ", error);
        });
    };

    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      try {
        const decoded = jwtDecode(accessToken);
        if (decoded.id) {
          setShopId(decoded.id);
        }
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
    fetchData();
  }, [shopId]);

  return (
    <div>
      <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 2, mb: 2 }}>
        <Link underline="hover" color="inherit" href="/">
          หน้าแรก
        </Link>
        <Typography color="text.primary">ธุรกรรม</Typography>
      </Breadcrumbs>
      <Typography component="h2" variant="h5" sx={{ mb: 2 }}>
        ธุรกรรม
      </Typography>

      <Box sx={{ flex: 1, position: "relative" }}>
        <Box sx={{ position: "absolute", inset: 0 }}>
          <Paper>
            <DataGrid
              rows={rows}
              columns={columns}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 25 },
                },
              }}
              pageSizeOptions={[25, 50, 100]}
            />
          </Paper>
        </Box>
      </Box>
    </div>
  );
};

export default Reports;
